<template>
  <modal
    name="item-modifiers"
    :width="isMobileDevice ? '90%' : '45%'"
    :adaptive="true"
    draggable=".window-header"
    :class="[
      'rounded-t-xxl vm-modal4 modal-container h-40 overflow-y flex items-center',
      menu.is_square_layout ? 'deleteModalSquare' : 'roundedmodal',
    ]"
    @before-close="$emit('before-close')"
    @before-open="openingModal"
    @opened="onModalOpened"
    height="90%"
    scrollable
    >
        <a
          @click="$modal.hide('item-modifiers')"
          class="h-10 w-10 rounded-full flex justify-center items-center absolute right-4 top-4 z-50"
        >
          <IconCancel
            :style="btnDestructiveBackground"
            :stroke="btnDestructiveIcon"
          />
        </a>
        <!-- img -->
        <div v-if="menu.product_images_enabled && selectedMenuCategory.enable_product_images" class="relative">
          <!-- <img
            v-if="currentItem.pictureUrl"
            :src="currentItem.pictureUrl"
            alt
            class="object-cover rounded-t-xxl w-full h-56"
          /> -->
          <Picture
            v-if="currentItem.pictureUrl"
            :src="currentItem.pictureUrl"
            alt
            class="object-cover rounded-t-xxl w-full h-64"
          />
        </div>
        <div
          :class="[
            'flex flex-col rounded-xxl h-full',
            currentItem.pictureUrl && menu.product_images_enabled && selectedMenuCategory.enable_product_images
              ? '-mt-10 '
              : '',
          ]"
        >
          <div class="z-20 rounded-xxl h-full" :style="menuSubCategoriesBackground ? menuSubCategoriesBackground : mainSubCategorysBackground">
            <div
              ref="shadowBottom"
              :class="['py-4 px-10 sticky top-0 rouned-t-xxl',
              menuSubCategoriesBackground || mainSubCategorysBackground ? '' : 'bg-white shadow-bottom '
              ]"
              :style="menuSubCategoriesBackground || mainSubCategorysBackground ? (menuSubCategoriesBackground ? menuSubCategoriesBackground : mainSubCategorysBackground ) : ''"
            >
              <button
              v-if="!currentItem.isComboDeal && modifiersSelectionGroups > 1 && modifierSelectionStep != 0"
              @click="previousStep"
              class="h-10 w-10 rounded-full flex justify-center items-center absolute left-4 top-4"
              :class="[
                !canGoBack
                  ? 'opacity-40 cursor-not-allowed'
                  : 'opacity-100',
              ]"
              :disabled="currentItem.isComboDeal ? (comboItemSelectionStep == 0 || !canGoBack) : false"
            >

              <IconBackArrow
                class="fill-current inline-block h-8 w-8 p-2 rounded-full cursor-pointer bg-background-red"
                fill="currentColor"
              />
            </button>
              <div class="w-full">
                <div
                  :class="[
                    ' font-bold flex-grow text-center flex self-center justify-center text-xl',
                  ]"
                  :style="makeStyles(listsText , hasKiosk&&titleFont,hasKiosk&&titleTextTransform)"
                >
                  {{ currentItem[`name_${language}`] }}
                </div>
              </div>
            </div>
            <div
              :class="['text-center text-xs md:text-lg px-10']"
              :style="itemDescription"
            >
              {{ currentItem["description" + "_" + language] }}
            </div>
            <div>
              <div
                class="px-6 allAdditions"
                v-for="(modifier, index) in modifiers"
                :key="modifier.AdditionGroupId"
              >
                <additions
                v-show="modifier.additionStep == modifierSelectionStep"
                  :modifier="modifier"
                  :modifiers="modifiers"
                  :key="index"
                  :allSelectedModifiers="selectedModifiers"
                  :isComboDeal="currentItem.isComboDeal"
                />
              </div>
            </div>
            <!-- fixed bottom-0 left-0 shadow-outer-box -->
            <div
              :class="[
                'pt-8 flex flex-col justify-center px-6 pb-6 items-center sticky bottom-0 left-0',
                menuSubCategoriesBackground || mainSubCategorysBackground ? '': 'OrderButton__backdrop',
              ]"
              :style="menuSubCategoriesBackground || mainSubCategorysBackground ? (menuSubCategoriesBackground ? menuSubCategoriesBackground : mainSubCategorysBackground ) : ''"
            >
              <div
              class="flex flex-row h-8 rounded-xl relative justify-center items-center mb-2"
            >
              <button
                @click.stop="deleteNumberOfOrders()"
                class="fill-current rounded-full focus:outline-none inline-block font-bold rounded-full m-2 w-14 p-1"
                :style="makeStyles(addMoreItemsIconBackground)"
              >
                  <IconMinus
                      :stroke="kioskPlusAndMinusButtons"
                      :style="btnOutlineIcon"
                      classes="w-5 md:w-5 h-5 xs:w-4 xs:h-4"
                  />
              </button>
              <input
                type="number"
                readonly
                class="font-bold text-xl focus:outline-none text-center ml-3 h-6 w-10 text-lg md:text-basecursor-default flex items-center outline-none justify-center bg-transparent"
                name="morePrders"
                :value="numberOfOrder"
                :style="addMoreItemsNumber"
              />
              <button
                @click.stop="addNumberOfOrders()"
                class="font-bold rounded-full cursor-pointer focus:outline-none m-2 w-14 p-1"
                :style="makeStyles(addMoreItemsIconBackground)"
    
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="md:w-5 h-5 md:h-5 xs:w-4 xs:h-4">
                  <path
                    d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                    fill="none"
                    :stroke="kioskPlusAndMinusButtons"
                    :style="btnOutlineIcon"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
              <!-- add button -->
              <!-- <button
                @click="
                  orderingEnabled &&
                  selectedMenuCategory.is_ordering_disabled == false
                    ? disableAddToCartButton
                      ? checkModifiers()
                      : addToCartWithModifiers()
                    : ''
                "
                :class="[
                  'w-full rounded-full relative bg-new-primary rounded px-2 text-md ml-4 h-8',
                  this.disableAddToCartButton && 'bg-primary-light',
                  orderingEnabled &&
                  selectedMenuCategory.is_ordering_disabled == false
                    ? disableAddToCartButton
                      ? 'opacity-40 cursor-not-allowed'
                      : 'opacity-100'
                    : 'opacity-40 cursor-not-allowed',
                ]"
                :style="paymentBtnBackground + paymentBtnText"
              >
                <div
                  v-if="
                    orderingEnabled &&
                      selectedMenuCategory.is_ordering_disabled == false
                  "
                >
                  <p >{{ lang["add_to_cart"][language] }}</p>
    
                  <p
                    :class="[
                      'h-full flex items-center positionPrice',
                    ]"
                    v-currency="itemPrice"
                  ></p>
                </div>
                <div v-else>
                  <p>{{ lang["ordering_not_available"][language] }}</p>
                </div>
              </button> -->

              <button
              v-if="
                (!disableAddToCartButton
                  && (modifiersSelectionGroups >1 ? modifierSelectionIndex == modifiersSelectionGroups - 1 : true))
              "
            @click="
                disableAddToCartButton
                  ? checkModifiers()
                  : addToCartWithModifiers()
              "
              :class="[
                'w-full rounded-full relative bg-new-primary rounded px-2 text-md ml-4 py-2',
                this.disableAddToCartButton && 'bg-primary-light',
                disableAddToCartButton
                  ? 'opacity-40 cursor-not-allowed'
                  : 'opacity-100',
              ]"
              :style="makeStyles(paymentBtnBackground , paymentBtnText)"
            >
              <div>

                <p v-if="disableAddToCartButton">
                  {{ lang["add_additions"][language] }}
                </p>
                <p v-else>{{ isMobileDevice ? lang["add_to_cart"][language] : lang["add_to_order"][language] }}</p>
                <p
                  class="positionPrice py-2 flex items-center"
                  v-currency="itemPrice"
                ></p>
              </div>
            </button>
            <button
              v-else
              @click="
                !enableNextStep
                  ? checkModifiers()
                  : nextStep()
              "
              :class="[
                'w-full rounded-full relative bg-new-primary rounded px-2 text-md ml-4 py-2',
                !enableNextStep 
                  ? 'opacity-40 cursor-not-allowed bg-primary-light'
                  : 'opacity-100',
              ]"
              :style="paymentBtnBackground + paymentBtnText"
            >
              <div>
                <p
                  v-if="
                    !enableNextStep 
                  "
                >
                  {{ lang["add_additions"][language] }}
                </p>
                <p v-else>{{ lang["next"][language] }}</p>
                <p
                  class="positionPrice py-2 flex items-center"
                  v-currency="itemPrice"
                ></p>
              </div>
            </button>
            </div>
          </div>
        </div>
        <!-- </div> -->
      </modal>
</template>

<script>
import Additions from "../components/Additions";
import { mapGetters } from 'vuex';
import lang from "../lang";
import IconCancel from "./icons/iconCancel.vue";
import IconMinus from "./icons/iconMinus.vue";
import IconBackArrow from "./icons/iconBackArrow.vue";
export default {
    components:{
    Additions,
    IconCancel,
    IconMinus,
    IconBackArrow
},
    props:{
        currentItem:{
            type:Object,
            require:true,
        },
        selectedModifiers:{
            type:Array,
            require:true,
        },
        disableAddToCartButton:{
            type:Boolean,
            require:true,
        },
        modifiers:{
            type:Array,
            require:true,
        },
        addToCartWithModifiers:{
            type:Function,
            require:true,
        },
        checkModifiers:{
            type:Function,
            require:true,
        },
        itemDescription:{
            type:String,
            require:true,
        },
        enableNextStep:{
            type:Boolean,
            require:true,
        },
        canGoBack:{
            type:Boolean,
            require:true,
        },
    },
data() {
    return {
      lang: lang,
      numberOfOrder: 1,
    }
},
computed:{
    ...mapGetters([
        'menu',
        'hasKiosk',
        "orderingEnabled",
        "selectedMenuCategory",
        "itemPrice",
        "language",
        "isMobileDevice",
        "modifierSelectionStep",
        "modifierSelectionIndex",
        "modifiersSelectionGroups"
        ]),
    ...mapGetters("Theme", [
        "titleFont",
        "titleTextTransform",
        "listsText",
        "mainSectionTopRadius",
        "paymentBtnText",
        "btnDestructiveIcon",
        "paymentBtnBackground",
        "btnDestructiveBackground",
        "mainSubCategorysBackground",
        "addButtonRadius",
        "addMoreItemsIconBackground",
        "kioskPlusAndMinusButtons",
        "btnOutlineIcon",
        "addMoreItemsNumber",
        "backgroundImage",
        "menuSubCategoriesBackground",
]),
},
methods: {
  onModalOpened() {
    if (this.mainSubCategorysBackground.includes('#FFFFFF') && (this.menuSubCategoriesBackground ? this.menuSubCategoriesBackground.includes('#FFFFFF') : true)) {
      const divElement = this.$refs.shadowBottom;
    divElement.classList.add('shadow-bottom');
    }
    },
  nextStep() {
    if (this.modifiersSelectionGroups > 1) {
      this.$store.commit("modifierSelectionStepIncrement");
    }
  },
  previousStep() {
      if (!this.currentItem.isComboDeal && this.modifiersSelectionGroups > 1) {
        this.$store.commit("modifierSelectionStepDecrement");
      }
  },
  addNumberOfOrders() {
      this.$store.commit("Cart/updateOrderItemCount", ++this.numberOfOrder);
  },
    
  deleteNumberOfOrders() {
    if (this.numberOfOrder > 1) {
        this.$store.commit("Cart/updateOrderItemCount", --this.numberOfOrder);
      }  
  },
  openingModal() {
    this.numberOfOrder = 1;
    this.$emit('open-modifier');
  }
},
}
</script>

<style scoped>

.positionPrice {
  position: absolute;
  top: 0;
  right: 25px;
}
.shadow-bottom {
  webkit-box-shadow: 0px 10px 25px 0px rgba(255,255,255,0.75);
  -moz-box-shadow: 0px 10px 25px 0px rgba(255,255,255,0.75);
  box-shadow: 0px 10px 25px 0px rgba(255,255,255,0.75);
}
.OrderButton__backdrop {
  /* background: linear-gradient(0deg, white, transparent); */
  background: white;
}
.vm--modal {
  height: 90vh !important;
}

</style>